const cookie = {
  en: {
    title: "We value your privacy",
    description: "We use cookies to enhance your experience, analyze site traffic, and for marketing purposes. By clicking \"Accept All\", you consent to our use of cookies.",
    privacyLink: "Privacy Policy",
    acceptAll: "Accept All",
    rejectNonEssential: "Essential Only",
    customize: "Customize",
    hideDetails: "Hide details",
    savePreferences: "Save Preferences",
    cat: { necessary: "Strictly Necessary", analytics: "Analytics", marketing: "Marketing" },
    catDesc: { necessary: "Required for the site to function. Cannot be disabled.", analytics: "Help us understand how visitors interact with the site.", marketing: "Used to deliver relevant ads and track campaigns." },
  },
  es: {
    title: "Valoramos tu privacidad",
    description: "Usamos cookies para mejorar tu experiencia, analizar el tráfico y con fines de marketing. Al hacer clic en \"Aceptar todo\", consientes el uso de cookies.",
    privacyLink: "Política de Privacidad",
    acceptAll: "Aceptar Todo",
    rejectNonEssential: "Solo Esenciales",
    customize: "Personalizar",
    hideDetails: "Ocultar detalles",
    savePreferences: "Guardar Preferencias",
    cat: { necessary: "Estrictamente Necesarias", analytics: "Analíticas", marketing: "Marketing" },
    catDesc: { necessary: "Necesarias para el funcionamiento del sitio. No se pueden desactivar.", analytics: "Nos ayudan a entender cómo interactúan los visitantes.", marketing: "Se utilizan para mostrar anuncios relevantes." },
  },
  fr: {
    title: "Nous respectons votre vie privée",
    description: "Nous utilisons des cookies pour améliorer votre expérience, analyser le trafic et à des fins marketing. En cliquant sur \"Tout accepter\", vous consentez à l'utilisation de cookies.",
    privacyLink: "Politique de Confidentialité",
    acceptAll: "Tout Accepter",
    rejectNonEssential: "Essentiels Uniquement",
    customize: "Personnaliser",
    hideDetails: "Masquer les détails",
    savePreferences: "Enregistrer les Préférences",
    cat: { necessary: "Strictement Nécessaires", analytics: "Analytiques", marketing: "Marketing" },
    catDesc: { necessary: "Indispensables au fonctionnement du site. Ne peuvent être désactivés.", analytics: "Nous aident à comprendre comment les visiteurs interagissent.", marketing: "Utilisés pour diffuser des publicités pertinentes." },
  },
  de: {
    title: "Wir schätzen Ihre Privatsphäre",
    description: "Wir verwenden Cookies, um Ihr Erlebnis zu verbessern, den Datenverkehr zu analysieren und für Marketingzwecke. Mit \"Alle akzeptieren\" stimmen Sie der Verwendung von Cookies zu.",
    privacyLink: "Datenschutzrichtlinie",
    acceptAll: "Alle Akzeptieren",
    rejectNonEssential: "Nur Notwendige",
    customize: "Anpassen",
    hideDetails: "Details ausblenden",
    savePreferences: "Einstellungen Speichern",
    cat: { necessary: "Unbedingt Erforderlich", analytics: "Analytik", marketing: "Marketing" },
    catDesc: { necessary: "Für die Funktion der Website erforderlich. Kann nicht deaktiviert werden.", analytics: "Helfen uns zu verstehen, wie Besucher interagieren.", marketing: "Werden verwendet, um relevante Werbung zu schalten." },
  },
  no: {
    title: "Vi verdsetter ditt personvern",
    description: "Vi bruker informasjonskapsler for å forbedre opplevelsen din, analysere trafikk og for markedsføringsformål. Ved å klikke \"Godta alle\" samtykker du til vår bruk av informasjonskapsler.",
    privacyLink: "Personvernerklæring",
    acceptAll: "Godta Alle",
    rejectNonEssential: "Kun Nødvendige",
    customize: "Tilpass",
    hideDetails: "Skjul detaljer",
    savePreferences: "Lagre Preferanser",
    cat: { necessary: "Strengt Nødvendige", analytics: "Analyse", marketing: "Markedsføring" },
    catDesc: { necessary: "Nødvendig for at nettstedet skal fungere. Kan ikke deaktiveres.", analytics: "Hjelper oss å forstå hvordan besøkende bruker nettstedet.", marketing: "Brukes til å vise relevante annonser og spore kampanjer." },
  },
  sv: {
    title: "Vi värnar om din integritet",
    description: "Vi använder cookies för att förbättra din upplevelse, analysera trafik och för marknadsföring. Genom att klicka \"Acceptera alla\" samtycker du till vår användning av cookies.",
    privacyLink: "Integritetspolicy",
    acceptAll: "Acceptera Alla",
    rejectNonEssential: "Endast Nödvändiga",
    customize: "Anpassa",
    hideDetails: "Dölj detaljer",
    savePreferences: "Spara Inställningar",
    cat: { necessary: "Strikt Nödvändiga", analytics: "Analys", marketing: "Marknadsföring" },
    catDesc: { necessary: "Krävs för att webbplatsen ska fungera.", analytics: "Hjälper oss förstå hur besökare interagerar.", marketing: "Används för att visa relevanta annonser." },
  },
  da: {
    title: "Vi værdsætter dit privatliv",
    description: "Vi bruger cookies til at forbedre din oplevelse, analysere trafik og til markedsføring. Ved at klikke \"Accepter alle\" samtykker du til vores brug af cookies.",
    privacyLink: "Privatlivspolitik",
    acceptAll: "Accepter Alle",
    rejectNonEssential: "Kun Nødvendige",
    customize: "Tilpas",
    hideDetails: "Skjul detaljer",
    savePreferences: "Gem Præferencer",
    cat: { necessary: "Strengt Nødvendige", analytics: "Analyse", marketing: "Markedsføring" },
    catDesc: { necessary: "Nødvendige for at hjemmesiden fungerer.", analytics: "Hjælper os med at forstå besøgendes adfærd.", marketing: "Bruges til at vise relevante annoncer." },
  },
  ar: {
    title: "نحن نقدر خصوصيتك",
    description: "نستخدم ملفات تعريف الارتباط لتحسين تجربتك وتحليل حركة المرور ولأغراض التسويق. بالنقر على \"قبول الكل\"، فإنك توافق على استخدامنا لملفات تعريف الارتباط.",
    privacyLink: "سياسة الخصوصية",
    acceptAll: "قبول الكل",
    rejectNonEssential: "الأساسية فقط",
    customize: "تخصيص",
    hideDetails: "إخفاء التفاصيل",
    savePreferences: "حفظ التفضيلات",
    cat: { necessary: "ضرورية", analytics: "تحليلية", marketing: "تسويقية" },
    catDesc: { necessary: "مطلوبة لعمل الموقع. لا يمكن تعطيلها.", analytics: "تساعدنا على فهم كيفية تفاعل الزوار.", marketing: "تُستخدم لعرض إعلانات ذات صلة." },
  },
  ja: {
    title: "プライバシーを大切にしています",
    description: "当サイトでは、体験の向上、トラフィック分析、マーケティング目的でCookieを使用しています。「すべて受け入れる」をクリックすると、Cookieの使用に同意したことになります。",
    privacyLink: "プライバシーポリシー",
    acceptAll: "すべて受け入れる",
    rejectNonEssential: "必須のみ",
    customize: "カスタマイズ",
    hideDetails: "詳細を隠す",
    savePreferences: "設定を保存",
    cat: { necessary: "必須", analytics: "分析", marketing: "マーケティング" },
    catDesc: { necessary: "サイトの動作に必要です。無効にできません。", analytics: "訪問者の行動を理解するのに役立ちます。", marketing: "関連する広告の配信に使用されます。" },
  },
  zh: {
    title: "我们重视您的隐私",
    description: "我们使用Cookie来提升您的体验、分析网站流量及用于营销目的。点击\"全部接受\"即表示您同意我们使用Cookie。",
    privacyLink: "隐私政策",
    acceptAll: "全部接受",
    rejectNonEssential: "仅必要",
    customize: "自定义",
    hideDetails: "隐藏详情",
    savePreferences: "保存偏好",
    cat: { necessary: "严格必要", analytics: "分析", marketing: "营销" },
    catDesc: { necessary: "网站正常运行所必需，无法禁用。", analytics: "帮助我们了解访客如何与网站互动。", marketing: "用于投放相关广告。" },
  },
  ko: {
    title: "개인정보를 소중히 합니다",
    description: "쿠키를 사용하여 경험을 개선하고 트래픽을 분석하며 마케팅 목적으로 활용합니다. \"모두 수락\"을 클릭하면 쿠키 사용에 동의하게 됩니다.",
    privacyLink: "개인정보 처리방침",
    acceptAll: "모두 수락",
    rejectNonEssential: "필수만",
    customize: "사용자 지정",
    hideDetails: "상세 숨기기",
    savePreferences: "설정 저장",
    cat: { necessary: "필수", analytics: "분석", marketing: "마케팅" },
    catDesc: { necessary: "사이트 작동에 필요합니다.", analytics: "방문자 상호작용을 이해하는 데 도움을 줍니다.", marketing: "관련 광고 전달에 사용됩니다." },
  },
  it: {
    title: "Rispettiamo la tua privacy",
    description: "Utilizziamo i cookie per migliorare la tua esperienza, analizzare il traffico e per scopi di marketing. Cliccando \"Accetta tutto\", acconsenti all'uso dei cookie.",
    privacyLink: "Informativa sulla Privacy",
    acceptAll: "Accetta Tutto",
    rejectNonEssential: "Solo Essenziali",
    customize: "Personalizza",
    hideDetails: "Nascondi dettagli",
    savePreferences: "Salva Preferenze",
    cat: { necessary: "Strettamente Necessari", analytics: "Analitici", marketing: "Marketing" },
    catDesc: { necessary: "Necessari per il funzionamento del sito.", analytics: "Ci aiutano a capire come i visitatori interagiscono.", marketing: "Utilizzati per mostrare annunci pertinenti." },
  },
  pt: {
    title: "Valorizamos sua privacidade",
    description: "Usamos cookies para melhorar sua experiência, analisar o tráfego e para fins de marketing. Ao clicar \"Aceitar tudo\", você consente o uso de cookies.",
    privacyLink: "Política de Privacidade",
    acceptAll: "Aceitar Tudo",
    rejectNonEssential: "Apenas Essenciais",
    customize: "Personalizar",
    hideDetails: "Ocultar detalhes",
    savePreferences: "Salvar Preferências",
    cat: { necessary: "Estritamente Necessários", analytics: "Analíticos", marketing: "Marketing" },
    catDesc: { necessary: "Necessários para o funcionamento do site.", analytics: "Nos ajudam a entender o comportamento dos visitantes.", marketing: "Usados para exibir anúncios relevantes." },
  },
  nl: {
    title: "Wij waarderen uw privacy",
    description: "Wij gebruiken cookies om uw ervaring te verbeteren, verkeer te analyseren en voor marketingdoeleinden. Door op \"Alles accepteren\" te klikken stemt u in met ons gebruik van cookies.",
    privacyLink: "Privacybeleid",
    acceptAll: "Alles Accepteren",
    rejectNonEssential: "Alleen Noodzakelijk",
    customize: "Aanpassen",
    hideDetails: "Details verbergen",
    savePreferences: "Voorkeuren Opslaan",
    cat: { necessary: "Strikt Noodzakelijk", analytics: "Analytisch", marketing: "Marketing" },
    catDesc: { necessary: "Vereist voor de werking van de site.", analytics: "Helpen ons te begrijpen hoe bezoekers de site gebruiken.", marketing: "Gebruikt om relevante advertenties te tonen." },
  },
  ru: {
    title: "Мы ценим вашу конфиденциальность",
    description: "Мы используем файлы cookie для улучшения вашего опыта, анализа трафика и в маркетинговых целях. Нажимая «Принять все», вы соглашаетесь с использованием cookie.",
    privacyLink: "Политика конфиденциальности",
    acceptAll: "Принять все",
    rejectNonEssential: "Только необходимые",
    customize: "Настроить",
    hideDetails: "Скрыть детали",
    savePreferences: "Сохранить настройки",
    cat: { necessary: "Необходимые", analytics: "Аналитические", marketing: "Маркетинговые" },
    catDesc: { necessary: "Необходимы для работы сайта.", analytics: "Помогают понять поведение посетителей.", marketing: "Используются для показа релевантной рекламы." },
  },
  pl: {
    title: "Cenimy Twoją prywatność",
    description: "Używamy plików cookie, aby ulepszyć Twoje doświadczenie, analizować ruch i w celach marketingowych. Klikając \"Akceptuj wszystkie\", wyrażasz zgodę na użycie plików cookie.",
    privacyLink: "Polityka Prywatności", acceptAll: "Akceptuj Wszystkie", rejectNonEssential: "Tylko Niezbędne", customize: "Dostosuj", hideDetails: "Ukryj szczegóły", savePreferences: "Zapisz Preferencje",
    cat: { necessary: "Niezbędne", analytics: "Analityczne", marketing: "Marketingowe" },
    catDesc: { necessary: "Wymagane do działania strony.", analytics: "Pomagają zrozumieć zachowanie odwiedzających.", marketing: "Służą do wyświetlania trafnych reklam." },
  },
  tr: {
    title: "Gizliliğinize değer veriyoruz",
    description: "Deneyiminizi geliştirmek, trafiği analiz etmek ve pazarlama amacıyla çerezler kullanıyoruz. \"Tümünü Kabul Et\"e tıklayarak çerez kullanımımıza onay verirsiniz.",
    privacyLink: "Gizlilik Politikası", acceptAll: "Tümünü Kabul Et", rejectNonEssential: "Sadece Gerekli", customize: "Özelleştir", hideDetails: "Ayrıntıları gizle", savePreferences: "Tercihleri Kaydet",
    cat: { necessary: "Zorunlu", analytics: "Analitik", marketing: "Pazarlama" },
    catDesc: { necessary: "Sitenin çalışması için gereklidir.", analytics: "Ziyaretçi davranışını anlamamıza yardımcı olur.", marketing: "İlgili reklamları göstermek için kullanılır." },
  },
  uk: {
    title: "Ми цінуємо вашу конфіденційність",
    description: "Ми використовуємо cookie для покращення вашого досвіду, аналізу трафіку та маркетингових цілей. Натискаючи \"Прийняти все\", ви погоджуєтесь з використанням cookie.",
    privacyLink: "Політика конфіденційності", acceptAll: "Прийняти все", rejectNonEssential: "Лише необхідні", customize: "Налаштувати", hideDetails: "Сховати деталі", savePreferences: "Зберегти налаштування",
    cat: { necessary: "Необхідні", analytics: "Аналітичні", marketing: "Маркетингові" },
    catDesc: { necessary: "Потрібні для роботи сайту.", analytics: "Допомагають зрозуміти поведінку відвідувачів.", marketing: "Використовуються для показу релевантної реклами." },
  },
  hi: {
    title: "हम आपकी गोपनीयता का सम्मान करते हैं",
    description: "हम आपके अनुभव को बेहतर बनाने, ट्रैफ़िक विश्लेषण और मार्केटिंग के लिए कुकीज़ का उपयोग करते हैं।",
    privacyLink: "गोपनीयता नीति", acceptAll: "सभी स्वीकारें", rejectNonEssential: "केवल आवश्यक", customize: "अनुकूलित करें", hideDetails: "विवरण छुपाएँ", savePreferences: "प्राथमिकताएँ सहेजें",
    cat: { necessary: "आवश्यक", analytics: "विश्लेषणात्मक", marketing: "विपणन" },
    catDesc: { necessary: "साइट के कार्य करने के लिए आवश्यक।", analytics: "विज़िटर व्यवहार को समझने में मदद करते हैं।", marketing: "प्रासंगिक विज्ञापन दिखाने के लिए।" },
  },
  fi: {
    title: "Arvostamme yksityisyyttäsi",
    description: "Käytämme evästeitä parantaaksemme kokemustasi, analysoidaksemme liikennettä ja markkinointitarkoituksiin.",
    privacyLink: "Tietosuojakäytäntö", acceptAll: "Hyväksy Kaikki", rejectNonEssential: "Vain Välttämättömät", customize: "Mukauta", hideDetails: "Piilota tiedot", savePreferences: "Tallenna Asetukset",
    cat: { necessary: "Välttämättömät", analytics: "Analytiikka", marketing: "Markkinointi" },
    catDesc: { necessary: "Sivuston toiminnan edellyttämät.", analytics: "Auttavat ymmärtämään kävijöiden käyttäytymistä.", marketing: "Käytetään olennaisten mainosten näyttämiseen." },
  },
  cs: {
    title: "Vážíme si vašeho soukromí",
    description: "Používáme cookies ke zlepšení vašeho zážitku, analýze provozu a pro marketingové účely.",
    privacyLink: "Zásady ochrany osobních údajů", acceptAll: "Přijmout vše", rejectNonEssential: "Pouze nezbytné", customize: "Přizpůsobit", hideDetails: "Skrýt podrobnosti", savePreferences: "Uložit předvolby",
    cat: { necessary: "Nezbytné", analytics: "Analytické", marketing: "Marketingové" },
    catDesc: { necessary: "Nutné pro fungování webu.", analytics: "Pomáhají porozumět chování návštěvníků.", marketing: "Používají se k zobrazování relevantních reklam." },
  },
  he: {
    title: "אנו מעריכים את פרטיותך",
    description: "אנו משתמשים בעוגיות כדי לשפר את החוויה שלך, לנתח תנועה ולמטרות שיווק.",
    privacyLink: "מדיניות פרטיות", acceptAll: "קבל הכל", rejectNonEssential: "חיוניים בלבד", customize: "התאמה אישית", hideDetails: "הסתר פרטים", savePreferences: "שמור העדפות",
    cat: { necessary: "הכרחיים", analytics: "אנליטיים", marketing: "שיווקיים" },
    catDesc: { necessary: "נדרשים לתפקוד האתר.", analytics: "עוזרים להבין התנהגות מבקרים.", marketing: "משמשים להצגת פרסומות רלוונטיות." },
  },
  bn: {
    title: "আমরা আপনার গোপনীয়তাকে মূল্য দিই",
    description: "আমরা আপনার অভিজ্ঞতা উন্নত করতে, ট্রাফিক বিশ্লেষণ করতে এবং বিপণনের জন্য কুকিজ ব্যবহার করি।",
    privacyLink: "গোপনীয়তা নীতি", acceptAll: "সব গ্রহণ করুন", rejectNonEssential: "শুধু প্রয়োজনীয়", customize: "কাস্টমাইজ", hideDetails: "বিস্তারিত লুকান", savePreferences: "পছন্দ সংরক্ষণ",
    cat: { necessary: "প্রয়োজনীয়", analytics: "বিশ্লেষণমূলক", marketing: "বিপণন" },
    catDesc: { necessary: "সাইট কাজ করার জন্য প্রয়োজন।", analytics: "দর্শকদের আচরণ বুঝতে সাহায্য করে।", marketing: "প্রাসঙ্গিক বিজ্ঞাপন দেখাতে ব্যবহৃত হয়।" },
  },
  vi: {
    title: "Chúng tôi trân trọng quyền riêng tư của bạn",
    description: "Chúng tôi sử dụng cookie để cải thiện trải nghiệm, phân tích lưu lượng và cho mục đích tiếp thị.",
    privacyLink: "Chính sách Bảo mật", acceptAll: "Chấp nhận Tất cả", rejectNonEssential: "Chỉ Thiết yếu", customize: "Tùy chỉnh", hideDetails: "Ẩn chi tiết", savePreferences: "Lưu Tùy chọn",
    cat: { necessary: "Thiết yếu", analytics: "Phân tích", marketing: "Tiếp thị" },
    catDesc: { necessary: "Cần thiết cho trang web hoạt động.", analytics: "Giúp hiểu hành vi của khách truy cập.", marketing: "Dùng để hiển thị quảng cáo liên quan." },
  },
  th: {
    title: "เราให้ความสำคัญกับความเป็นส่วนตัวของคุณ",
    description: "เราใช้คุกกี้เพื่อปรับปรุงประสบการณ์ วิเคราะห์การเข้าชม และเพื่อการตลาด",
    privacyLink: "นโยบายความเป็นส่วนตัว", acceptAll: "ยอมรับทั้งหมด", rejectNonEssential: "เฉพาะที่จำเป็น", customize: "ปรับแต่ง", hideDetails: "ซ่อนรายละเอียด", savePreferences: "บันทึกการตั้งค่า",
    cat: { necessary: "จำเป็น", analytics: "วิเคราะห์", marketing: "การตลาด" },
    catDesc: { necessary: "จำเป็นสำหรับการทำงานของเว็บไซต์", analytics: "ช่วยให้เข้าใจพฤติกรรมของผู้เข้าชม", marketing: "ใช้แสดงโฆษณาที่เกี่ยวข้อง" },
  },
  id: {
    title: "Kami menghargai privasi Anda",
    description: "Kami menggunakan cookie untuk meningkatkan pengalaman Anda, menganalisis lalu lintas, dan untuk tujuan pemasaran.",
    privacyLink: "Kebijakan Privasi", acceptAll: "Terima Semua", rejectNonEssential: "Hanya Penting", customize: "Sesuaikan", hideDetails: "Sembunyikan detail", savePreferences: "Simpan Preferensi",
    cat: { necessary: "Wajib", analytics: "Analitik", marketing: "Pemasaran" },
    catDesc: { necessary: "Diperlukan agar situs berfungsi.", analytics: "Membantu memahami perilaku pengunjung.", marketing: "Digunakan untuk menampilkan iklan relevan." },
  },
  ms: {
    title: "Kami menghargai privasi anda",
    description: "Kami menggunakan kuki untuk meningkatkan pengalaman anda, menganalisis trafik dan untuk tujuan pemasaran.",
    privacyLink: "Dasar Privasi", acceptAll: "Terima Semua", rejectNonEssential: "Hanya Penting", customize: "Sesuaikan", hideDetails: "Sembunyikan butiran", savePreferences: "Simpan Pilihan",
    cat: { necessary: "Wajib", analytics: "Analitik", marketing: "Pemasaran" },
    catDesc: { necessary: "Diperlukan untuk laman web berfungsi.", analytics: "Membantu memahami tingkah laku pelawat.", marketing: "Digunakan untuk memaparkan iklan berkaitan." },
  },
};

export default cookie;
